/**
 * @fileoverview Cycle insights panel for the Period Calculator.
 * Updates the insights section with cycle day, ovulation, and next period dates.
 * @module period-tracker/period-insights
 */

/* global femcare */

femcare.periodTracker = femcare.periodTracker || {};

/**
 * @namespace femcare.periodTracker.insights
 * @description Manages the cycle insights panel display.
 */
femcare.periodTracker.insights = {
    container: null,
    cycleDayCurrentElement: null,
    cycleDayEndElement: null,
    ovulationStartElement: null,
    nextPeriodStartElement: null,

    /**
     * Initializes the insights module.
     * @returns {boolean} True if container found
     */
    init: function () {
        return this.cacheElements();
    },

    /**
     * Caches DOM element references.
     * @returns {boolean} True if container found
     */
    cacheElements: function () {
        this.container = document.querySelector('.cycle-insights');

        if (!this.container) {
            return false;
        }

        this.cycleDayCurrentElement = document.querySelector('.cycle-insights__value-current[data-insight="cycle-day"]');
        this.cycleDayEndElement = document.querySelector('.cycle-insights__value-end[data-insight="cycle-day"]');
        this.ovulationStartElement = document.querySelector('[data-insight="ovulation-start"]');
        this.nextPeriodStartElement = document.querySelector('[data-insight="next-cycle-start"]');

        return true;
    },

    /**
     * Refreshes DOM references after HTML replacement.
     */
    refresh: function () {
        this.cacheElements();
    },

    /**
     * Updates the cycle insights based on selected date.
     * @param {Date} selectedDate - Currently selected date
     */
    update: function (selectedDate) {
        if (!this.container) {
            return;
        }

        const cycleLogic = femcare.periodTracker.cycleLogic;
        const phase = cycleLogic.getPhaseForDate(selectedDate);

        this.updatePhaseVisibility(phase);
        this.updateCycleDay(selectedDate);
        this.updateOvulationDate(selectedDate);
        this.updateNextPeriodDate(selectedDate);
    },

    /**
     * Shows/hides elements based on current phase.
     * @param {string} currentPhase - Current phase name
     */
    updatePhaseVisibility: function (currentPhase) {
        const phaseElements = this.container.querySelectorAll('[data-phase]');

        phaseElements.forEach(element => {
            const elementPhase = element.getAttribute('data-phase');
            if (elementPhase === currentPhase) {
                element.classList.remove('hidden');
            } else {
                element.classList.add('hidden');
            }
        });
    },

    /**
     * Updates the cycle day display.
     * @param {Date} selectedDate - Selected date
     */
    updateCycleDay: function (selectedDate) {
        const cycleLogic = femcare.periodTracker.cycleLogic;

        if (this.cycleDayCurrentElement) {
            const cycleDay = cycleLogic.getCycleDayForDate(selectedDate);
            this.cycleDayCurrentElement.textContent = cycleDay;
        }

        if (this.cycleDayEndElement) {
            this.cycleDayEndElement.textContent = cycleLogic.menstrualCycle;
        }
    },

    /**
     * Updates the ovulation date display.
     * @param {Date} selectedDate - Selected date
     */
    updateOvulationDate: function (selectedDate) {
        if (!this.ovulationStartElement) {
            return;
        }

        const cycleLogic = femcare.periodTracker.cycleLogic;
        const ovulationDate = cycleLogic.calculateNextOvulationDate(selectedDate);

        this.ovulationStartElement.textContent = ovulationDate
            ? cycleLogic.formatDateDisplay(ovulationDate)
            : 'Not available';
    },

    /**
     * Updates the next period date display.
     * @param {Date} selectedDate - Selected date
     */
    updateNextPeriodDate: function (selectedDate) {
        if (!this.nextPeriodStartElement) {
            return;
        }

        const cycleLogic = femcare.periodTracker.cycleLogic;
        const nextPeriodDate = cycleLogic.calculateNextPeriodDate(selectedDate);

        this.nextPeriodStartElement.textContent = nextPeriodDate
            ? cycleLogic.formatDateDisplay(nextPeriodDate)
            : 'Not available';
    }
};
